interface FooterItem {
  id: number;
  url: string;
  text: string;
}

export const FooterList: FooterItem[] = [
  {
    id: 1,
    url: 'https://www.heum.report/',
    text: '혜움 시스템',
  },
  {
    id: 2,
    url: 'https://recruit.heumtax.com/',
    text: '세무사 지원',
  },
  {
    id: 3,
    url: 'https://page.heumtax.com/terms',
    text: '서비스 이용 약관',
  },
  {
    id: 4,
    url: 'https://www.heumtax.com/branch',
    text: '혜움 지점 안내',
  },
  {
    id: 5,
    url: 'https://join.heumtax.com/',
    text: '기장직원 지원',
  },
  {
    id: 6,
    url: 'https://page.heumtax.com/privacy-policy',
    text: '개인정보 취급 방침',
  },
  {
    id: 7,
    url: 'https://branch.heumtax.com/',
    text: '지점 문의',
  },
  {
    id: 8,
    url: process.env.NODE_ENV === 'production' ? 'https://app.sole.overtax.co.kr/cert-center' : 'https://sole-app.stag.overtax.co.kr/cert-center',
    text: '공동인증센터',
  },
]
